import React from "react";
import { isBrowser } from "react-device-detect";

const LabTransactionItem = (props) => {
    const {
        id,
        jalali_created_at,
        orderId,
        amount,
        comment
    } = props;
    return (
        <div className={isBrowser ? "order-item bg-white shadow-sm rounded" : "order-item-lab-mobile order-item bg-white shadow-sm rounded"}>
            <div className='order-id'>
                <div>#{id}</div>
                <div>{jalali_created_at}</div>
            </div>
            <div className='flex-row'>
                <div className='item-detail'>
                    <div className='key'>
                         کد سفارش :
                    </div>
                    <div className='value'>
                        {orderId ?? '-'}
                    </div>
                </div>
                <div className='item-detail'>
                    <div className='key'>
                        مبلغ :
                    </div>
                    <div className='value' style={{direction:'ltr'}}>
                        {amount.toString().replace(new RegExp(',', 'g'), '').replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}
                    </div>
                </div>
            </div>
            <div className='flex-row'>
                <div className='item-detail'>
                    <div className='key'>
                        توضیحات :
                    </div>
                    <div className={isBrowser ? "value" : "value blue-value"} style={{direction:'rtl'}}>
                        {comment}
                    </div>
                </div>
            </div>
        </div>
    )
};
export default LabTransactionItem;